import fetch from '../utils/fetch';

// 智能表列表查询
export function getList(params) {
    return fetch({
        method: 'GET',
        url: '/merchant/list',
        params
    })
}

export function save(data) {
    return fetch({
        method: 'POST',
        url: '/merchant/save',
        data
    })
}

// 删除 POST
export function del(params) {
    return fetch({
        method: 'POST',
        url: '/merchant/delete',
        params
    })
}

export function update(data) {
  return fetch({
      method: 'POST',
      url: '/merchant/update',
      data
  })
}

export function getMerchantInfoByFid(params) {
  return fetch({
      method: 'POST',
      url: '/merchant/getMerchantInfoByFid',
      params
  })
}

